import AssetTypeList from "../components/asset-type/AssetTypeCrud";

const AssetTypeCrudPage = () => {
  return (
    <>
      <AssetTypeList />
    </>
  );
};

export default AssetTypeCrudPage;
